export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7361.57696270.jpg";